<template>
  <div class="countries_all">
    <template>
      <Breadcrumb :items="items" />
      <!-- @filterFired="filterFired" -->
      <the-filter
        :inputs="inputs"
        customName="الحالة"
        :types="reportCancelOrderReasons"
        customName2="سبب الالغاء"
      />
      <template>
        <!-- Start Main Section -->
        <main class="magic-table-wrapper">
          <v-data-table
            class="thumb strip"
            :headers="headers"
            :items="rows"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            hide-default-footer
            :items-per-page="rows.length"
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <!-- <template v-slot:[`item.client`]="{ item }">
                <div class="d-flex flex-column">
                  <img
                    :src="item.client.avatar"
                    :alt="item.client.fullname"
                    width="50"
                    height="50"
                    class="rounded-circle"
                    @click="show_model_1"
                  />
                  <span>{{ item.client.fullname }}</span>
                </div>
              </template>-->

            <template v-slot:[`item.cancel_reason_name`]="{ item }">
              <div v-if="item.cancel_reason_name">
                <div>{{ item.cancel_reason_name }}</div>
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.driver`]="{ item }">
              <div v-if="item.driver">
                <router-link :to="`/driver/show/${item.driver.id}`">
                  <img class="image" :src="item.driver.image" alt="" />
                  <div>{{ item.driver.full_name }}</div>
                </router-link>
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.driver_name`]="{ item }">
              <div v-if="item.driver_name">
                <span>{{ item.driver_name }}</span>
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.driver_phone`]="{ item }">
              <div v-if="item.driver_phone">
                <span
                  >({{ item.driver_phone_code }}) {{ item.driver_phone }}</span
                >
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.delivery_type`]="{ item }">
              <div v-if="item.delivery_type">
                {{ item.delivery_type == "google_restaurant" ? "جوجل" : "زوز" }}
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.total_price`]="{ item }">
              <div v-if="item.total_price">
                {{ item.total_price.toFixed(1) }}
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.vat_price`]="{ item }">
              <div v-if="item.vat_price">
                {{ item.vat_price.toFixed(1) }}
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.driver_amount`]="{ item }">
              <div v-if="item.driver_amount">
                {{ item.driver_amount.toFixed(1) }}
              </div>
              <span v-else> لا يوجد </span>
            </template>
            <template v-slot:[`item.delivery_price`]="{ item }">
              <div v-if="item.delivery_price">
                {{ item.delivery_price.toFixed(1) }}
              </div>
              <span v-else> لا يوجد </span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <div class="action">
                <div>
                  <span class="status">
                    {{
                      item.status == "client_cancel"
                        ? "تم الالغاء من العميل"
                        : "تم الالغاء من النظام"
                    }}
                  </span>
                </div>
              </div>
            </template>
            <!-- <template v-slot:[`item.order_details.delivery_date`]="{ item }">
                <span>
                  {{
                    item.order_details.delivery_date
                      ? item.order_details.delivery_date
                      : "لا يوجد"
                  }}
                </span>
              </template> -->
            <!-- <template v-slot:[`item.order_details.delivery_timing`]="{ item }">
                <span>
                  {{
                    item.order_details.delivery_date
                      ? item.order_details.delivery_date
                      : "لا يوجد"
                  }}
                </span>
              </template> -->
            <!-- <template v-slot:[`item.to`]="{ item }">
                <router-link :to="`/users/show/${item.to.id}`">
                  {{ item.to.fullname }}
                </router-link>
              </template> -->
            <!-- End:: Users Routes -->

            <!-- Start:: Report Reason Modal Button -->
            <template v-slot:[`item.report_reason`]="{ item }">
              <v-icon
                class="show"
                small
                @click="controlReportReasonModalModal(item.report_reason)"
                v-if="item.report_reason"
              >
                fal fa-eye
              </v-icon>

              <span v-else>_</span>
            </template>
            <!-- End:: Report Reason Modal Button -->

            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon class="show" small @click="showItem(item)">
                  fal fa-eye
                </v-icon>
                <!-- <v-icon class="edit" small @click="editItem(item)">
                    fal fa-edit
                  </v-icon> -->
                <!-- <v-icon class="delete" small @click="deleteItem(item)">
                    fal fa-trash
                  </v-icon> -->
              </div>
            </template>
            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top v-slot:[`item.actions`]="{ item }">
              <section class="table-buttons d-inline-flex p-0 mb-2">
                <export-excel
                  v-if="rows.length > 0"
                  :data="rows"
                  :fields="jsonFields"
                  name="الطلبات الملغاة.xlsx"
                  type="xls"
                  class="button_delete ml-5"
                >
                  تحميل Excel
                </export-excel>
              </section>
            </template>
          </v-data-table>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <!-- End Pagination -->

        <!-- Start Image_Model -->
        <base-model
          @closeModel="model_1.show_model = false"
          :show="model_1.show_model"
        >
          <div class="image">
            <img
              v-if="model_1.model_img_src"
              :src="model_1.model_img_src"
              alt="..."
            />
          </div>
        </base-model>
        <!-- End Image_Model -->
      </template>
      <!-- :custom-filter="helper_filterSearch" -->
    </template>
  </div>
</template>

<script>
import TheFilter from "@/components/Filters/TheFilter.vue";
import { mapGetters } from "vuex";
export default {
  components: { TheFilter },
  data() {
    return {
      // breadcrumb
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: "تقرير الطلبات الملغاة",
          disabled: true,
          href: "",
        },
      ],
      button_: {
        id: "",
      },

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      loading: false,
      rows: [],
      statistics: [],
      search: null,
      expandData: null,
      order_types: [
        {
          id: "client",
          name: "عميل",
        },
        {
          id: "restaurant",
          name: "مطعم",
        },
        {
          id: "driver",
          name: "سائق",
        },
      ],
      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
      // ========== Filter
      inputs: [
        {
          keyName: "user_type",
          user_types: [
            {
              id: "client_cancel",
              name: "ملغية من العميل",
            },
            {
              id: "admin_cancel",
              name: "ملغية من الادمن",
            },
          ],
        },
        {
          keyName: "type",
        },
        {
          keyName: "start_date",
          value: new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            2
          )
            .toISOString()
            .slice(0, 10),
        },
        {
          keyName: "end_date",
          value: new Date().toISOString().slice(0, 10),
        },
      ],
      reportCancelOrderReasons: [],
    };
  },

  methods: {
    mapItem(data) {
      this.expandData = {
        [this.$t("labels.created_at")]: data.created_at,
      };
    },
    setRows() {
      const getInputValue = (key) => {
        const input = this.inputs.find((i) => i.keyName === key);
        return input ? input.value : null;
      };

      this.$axios({
        method: "GET",
        url: "report/cancel-orders",
        params: {
          // page: this.paginations.current_page,
          status: this.$route.query.user_type
            ? this.$route.query.user_type
            : "",
          cancel_reason_id: this.$route.query.type
            ? this.$route.query.type
            : "",
          from: this.$route.query.start_date || getInputValue("start_date"),
          to: this.$route.query.end_date || getInputValue("end_date"),
          // payment_method: this.$route.query.payment_method,
        },
      })
        .then((res) => {
          // this.paginations.last_page = res.data.meta?.last_page;
          // this.paginations.items_per_page = res.data.meta?.per_page;
          // this.total = res.data.meta?.total;
          this.rows = res.data.data;
          this.loading = false;
          // console.log(res);

          // this.statistics = [];
          // for (const [key, value] of Object.entries(res.data.data)) {
          //   this.statistics.push({
          //     title: this.$t(key),
          //     count: value,
          //   });
          // }
        })
        .catch((err) => {
          // console.log(err.response.data.messages);
          let message =
            err.response?.data.message ?? err.response?.data.messages;
          this.$iziToast.error({
            title: this.$t("validation.error"),
            message: message,
          });
          this.loading = false;
        });
    },
    imageError(index) {
      if (this.rows[index].partner) {
        this.rows[
          index
        ].partner.vehicle.image = require("@/assets/images/icons/no-data.gif");
      }
    },

    showItem(item) {
      this.$router.push({ path: `/trips/show/` + item.id });
    },

    fetchData(e) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: e }),
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.setRows();
    },
    getUser(user) {
      if (user == "client") return "العملاء";
      if (user == "restaurant") return "المطاعم";
      if (user == "driver") return "السائقين";
    },
    getCancelOrderReasons() {
      this.$axios({
        method: "GET",
        url: "cancel_reason_not_paginated?reason_type=cancel",
      }).then((res) => {
        this.reportCancelOrderReasons = res.data.data.map((x) => {
          return {
            id: x.id,
            name: x.name,
          };
        });
      });
    },
    handleRouteChange() {
      // Only handle the page parameter for this component
      const { page } = this.$route.query;

      // Update pagination
      this.paginations.current_page = page ? +page : 1;

      // Call setRows with nextTick to ensure all data is updated
      this.$nextTick(() => {
        this.setRows();
      });
    },
  },
  watch: {
    $route: {
      handler() {
        this.handleRouteChange();
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    jsonFields() {
      return {
        "سبب الالغاء": "cancel_reason_name",
        "عدد الطلبات": "total_orders_count",
        "مرحلة اللالغاء": "status",
        "سعر الطلب": "total_price",
        "سعر التوصيل": "delivery_price",
        "مبلغ السائق": `driver_amount`,
        "اجمالي الخصومات على الطلب ": "coupon_amount",
      };
    },

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
            width: "80",
          },
          {
            text: "سبب الالغاء",
            align: "center",
            value: "cancel_reason_name",
            sortable: false,
          },
          {
            text: "عدد الطلبات",
            align: "center",
            value: "total_orders_count",
            sortable: false,
          },
          {
            text: "مرحلة اللالغاء",
            align: "center",
            value: "status",
            sortable: false,
          },
          {
            text: "سعر الطلب",
            align: "center",
            value: "total_price",
            sortable: false,
          },

          {
            text: "سعر التوصيل",
            align: "center",
            value: "delivery_price",
            sortable: false,
          },
          {
            text: "مبلغ السائق",
            align: "center",
            value: `driver_amount`,
            sortable: false,
            width: "200",
            padding: "2",
          },
          {
            text: "اجمالي الخصومات على الطلب ",
            align: "center",
            value: "coupon_amount",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },

  created() {
    this.control = this.$permission.setControls(this.$route.path);
    // if (this.$route.query.page) {
    //   this.pagination.current_page = +this.$route.query.page;
    // }
    // setTimeout(() => {
    // }, 100);
    // Removed redundant handleRouteChange() since watcher is immediate
    this.getCancelOrderReasons();
  },
};
</script>
